import Button from '@/src/components/atom/Button';
import Dialog from '@/src/components/atom/Dialog';
import { BUTTON_CONST } from '@/src/constants/buttons';
import { RecyclingCouponDto } from '@/src/models/RecyclingCouponDto';
import SectionLabel from '@/src/components/molecule/SectionLabel';
import dayjs from 'dayjs';
import Badge from '@/src/components/atom/Badge';
import ImagePreview from '@/src/components/molecule/ImagePreview';
import { OPTIONS_CONST } from '@/src/constants/options';

interface RecyclingCouponDetailModalProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  onOkClick: () => void;
  data?: RecyclingCouponDto;
}

export default function RecyclingCouponDetailModal({
  open: openProps,
  onOpenChange: onOpenChangeProps,
  onOkClick,
  data,
}: RecyclingCouponDetailModalProps) {
  // event
  const handleCloseModal = () => {
    onOpenChangeProps(false);
  };

  // render
  const renderFooter = () => {
    return (
      <div className="flex justify-end gap-2">
        <Button
          className="flex-1"
          buttonColor="outline"
          onClick={handleCloseModal}
        >
          {BUTTON_CONST.cancel}
        </Button>
        <Button className="flex-1" onClick={onOkClick}>
          {BUTTON_CONST.editShort}
        </Button>
      </div>
    );
  };

  return data ? (
    <Dialog
      open={openProps}
      onOpenChange={handleCloseModal}
      contentProps={{
        style: {
          width: 'calc(100vw - 24px)',
        },
        className: 'max-w-[697px]',
      }}
      title="배송비 쿠폰 상세"
      footer={renderFooter()}
    >
      <div className="flex flex-col gap-6">
        <SectionLabel label="후원사 명" value={data.sponsorName} />
        <SectionLabel
          label="게시 기간"
          value={`${dayjs(data.onAt).format('YYYY-MM-DD')} ~ ${dayjs(
            data.offAt,
          ).format('YYYY-MM-DD')}`}
        />
        <SectionLabel
          label="노출 여부"
          value={
            <Badge badgeColor={data.isExposed ? 'lightGreen' : 'lightGray'}>
              {data.isExposed
                ? OPTIONS_CONST.exposed
                : OPTIONS_CONST.notExposed}
            </Badge>
          }
        />
        <SectionLabel
          label="노출 범위"
          value={
            data.exposeService === 'APP'
              ? OPTIONS_CONST.onlyApp
              : OPTIONS_CONST.onlyWeb
          }
        />
        <SectionLabel
          label="쿠폰 이미지"
          value={
            <ImagePreview
              imgSrc={data.couponMedia.bufferFullUrl}
              width={128}
              height={128}
            />
          }
        />
        <SectionLabel
          label="등록 일시"
          value={dayjs(data.createdAt).format('YYYY-MM-DD HH:mm:ss')}
        />
        <SectionLabel label="등록 관리자" value={data.administrator.name} />
      </div>
    </Dialog>
  ) : null;
}
